import { UWCFulfilledConstants, UWCPendingConstants, UWCRejectedConstants } from '../actions';

const initialState = {
    users: [],
    total: 0,
    loading: false,
    error: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case UWCFulfilledConstants.UWC_LOADED:
            return {
                ...initialState,
                users: action.payload.users,
                total: action.payload.total,
                loading: false
            };
        case UWCPendingConstants.UWC_LOADED:
            return {
                ...state,
                loading: true
            };
        case UWCRejectedConstants.UWC_LOADED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
